

































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import { MasterCarStateDataModule } from '@/app/store/modules/masterCar'
import { GalleryImageModule } from '@/app/store/modules/galleryImage'

@Component({
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
    pagination: Pagination,
  },
})
export default class extends Vue {
  // Property Global
  private selected = []
  public get isLoading() {
    return MasterCarStateDataModule.isLoading
  }
  public get page() {
    return MasterCarStateDataModule.Pages
  }
  public get limit() {
    return MasterCarStateDataModule.Limit
  }
  public created() {
    this.getImage()
    this.getData()
  }
  public getImage() {
    GalleryImageModule.getGalleryImageData()
  }
  public getData() {
    MasterCarStateDataModule.getMasterCarData()
  }
  public get trainingCategoryData() {
    return MasterCarStateDataModule.masterCarData
  }
  public get imageDataCategory() {
    return GalleryImageModule.galleryImageData
  }

  // Property Top Menu
  private searchInput = ''
  private funcSearch(item) {
    //  console.log('Panggil action get with query search', item)
  }

  public get fields() {
    return MasterCarStateDataModule.fields
  }

  // Property Pagination
  private onPageNumChanged(limit: any) {
    MasterCarStateDataModule.paginationParam.paging.limit = limit
    this.getData()
  }
  private funcFirstPage() {
    MasterCarStateDataModule.paginationParam.paging.page = 1
    this.getData()
  }

  private funcPrevPage() {
    MasterCarStateDataModule.paginationParam.paging.page =
      MasterCarStateDataModule.paginationParam.paging.page - 1
    this.getData()
  }
  private funcNextPage() {
    MasterCarStateDataModule.paginationParam.paging.page =
      MasterCarStateDataModule.paginationParam.paging.page + 1
    this.getData()
  }

  private funcLastPage() {
    MasterCarStateDataModule.paginationParam.paging.page =
      (this.trainingCategoryData.pagination &&
        this.trainingCategoryData.pagination.pageCount) ||
      0
    this.getData()
  }

  private onRowSelected(items) {
    this.selected = items
  }
  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
}
